export const actionTypes = {
  HAS_UNITS_REQUEST_START: 'MY_TAXES.HAS_UNITS.REQUEST_START',
  HAS_UNITS_REQUEST_SUCCESS: 'MY_TAXES.HAS_UNITS.REQUEST_SUCCESS',
  HAS_UNITS_REQUEST_FAILURE: 'MY_TAXES.HAS_UNITS.REQUEST_FAILURE',
};

export function startRequest(data) {
  return {
    type: actionTypes.HAS_UNITS_REQUEST_START,
    payload: data,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.HAS_UNITS_REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.HAS_UNITS_REQUEST_FAILURE,
    payload: error,
  };
}
